import classNames from 'classnames'
import { CSSProperties, FC, InputHTMLAttributes, LegacyRef, useState } from 'react'

import { Flex } from 'components/uiKit'
import { colors } from 'shared/constants/values'

import { TextPromo } from '../TextPromo/TextPromo'

import s from './InputPromo.module.scss'

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  containerStyle?: CSSProperties
  onChangeText?: (value: string) => void
  suffix?: string
  inputRef?: LegacyRef<HTMLInputElement> | undefined
}

export const InputPromo: FC<IInputProps> = ({
  value,
  className,
  suffix,
  onChangeText,
  onChange,
  inputRef,
  containerStyle,
  ...other
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false)

  return (
    <div
      style={containerStyle}
      className={classNames(s.inputWrapper, className, {
        [s.inputWrapperFocused]: isFocused,
      })}
    >
      <Flex align="center">
        {suffix && (
          <TextPromo style={{ marginRight: 8, color: colors.black }} color="gray" fontFamily="ASLHauss" size="s20">
            {suffix}
          </TextPromo>
        )}
        <input
          className={s.input}
          type="text"
          value={value}
          onChange={onChangeText ? ({ target: { value } }) => onChangeText(value) : onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          ref={inputRef}
          {...other}
        />
      </Flex>
    </div>
  )
}
